import { htmlElements } from './htmlElements'
import type { CheckoutHandler } from './sdk'

export const disableSubmit = (checkoutInstance: CheckoutHandler): void => {
    const { submitButton } = htmlElements()
    checkoutInstance.creatingContract = true
    if (submitButton) {
        submitButton?.setAttribute('disabled', 'true')
    }
}

export const enableSubmit = (checkoutInstance: CheckoutHandler): void => {
    const { submitButton } = htmlElements()
    checkoutInstance.creatingContract = false
    if (submitButton) {
        submitButton?.removeAttribute('disabled')
    }
}
